// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__21pPm","alert":"SettungsInbox_alert__1Z-BK"};